'use strict';

export default function chartConfig(scope) {
  'ngInject';

  let chartConfig = {
    chart: {
      type: 'line',
      height: 150,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    title: false,
    xAxis: {
      crosshair: true,
      labels: {
        formatter: function () {
          let style = '';
          let day = scope.$filter('dayFilter')(this.value);
          if(day === '日') {
            style = 'color: #ff3131';
          } else if(day === '土') {
            style = 'color: #3737ff';
          }

          return `<span style="${style}">${scope.$filter('date')(this.value, 'M/d')} (${day})</span>`;
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: false
    },
    plotLines: [
      {
        id: 'target-date'
      }
    ],
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function () {
        let tip_format = `<tspan style='font-size: 12px'>${scope.$filter('date')(this.x, 'M/d')} (${scope.$filter('dayFilter')(this.x)})</tspan>`;

        const pointNormal = this.points[0];
        const pointError = this.points[1];
        tip_format += '<br/><span style="color:' + pointNormal.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + pointNormal.series.name + ': ';
        tip_format += pointNormal.y + " 回";
        tip_format += "</span>";
        tip_format += '<br/><span style="color:' + pointError.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + pointError.series.name + ': ';
        tip_format += pointError.y + " 回";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: {column: {grouping: false}},
    series: [
      {
        name: '正常系',
        color: '#6ee876',
        marker: {symbol: 'circle'},
        lineWidth: 2,
        cursor: 'pointer'
      },
      {
        name: '異常系',
        color: '#ff3535',
        marker: {symbol: 'circle'},
        lineWidth: 2,
        cursor: 'pointer'
      }
    ]
  };

  return chartConfig;
}



// WEBPACK FOOTER //
// ./public/dev/app/event_report/event_report.config.js